document.addEventListener('DOMContentLoaded', function () {
    var swiper_el = document.querySelector('#aboutSwiperCarousel');
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    let swiper;

    if (isMobile) {
        swiper = new Swiper(".mySwiper", {
            effect: 'flip',
            autoplay: {
                delay: 3000,
            },
            loop: true,
            spaceBetween: 20,
            slidesPerView: 1.75,
            speed: 750,
            on: {
                afterInit: function() {
                    swiper_el.classList.remove('is-loading');
                    swiper_el.classList.add('is-ready');
                },
            }
        });
    } else {
        swiper = new Swiper(".mySwiper", {
            grabCursor: true,
            spaceBetween: 20,
            slidesPerView: 1.75,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }, on: {
                afterInit: function() {
                    swiper_el.classList.remove('is-loading');
                    swiper_el.classList.add('is-ready');
                },
            }, breakpoints: {
                // when window width is >= 1000px
                1000: {
                slidesPerView: 2.5,
                spaceBetween: 50,
                },
            },
        })
    }


});